import { useSessionStorage, useLocalStorage } from '@vueuse/core'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useUiStore = defineStore('ui', () => {
  const fullscreen = useLocalStorage('ui-fullscreen', false)
  const blockScreen = ref(false) // full screen spinner
  const isLoggingOut = ref(false)
  const returnUrl = useSessionStorage('return-url', undefined, {
    serializer: {
      read: raw => {
        if (raw == null || raw === '' || raw === 'undefined') {
          return undefined
        }
        try {
          return JSON.parse(raw)
        } catch {
          return undefined
        }
      },
      write: val => (val === undefined ? null : JSON.stringify(val)),
    },
  })
  const listconfig = useLocalStorage('listconfig', {})

  return { fullscreen, blockScreen, isLoggingOut, returnUrl, listconfig }
})
